// extracted by mini-css-extract-plugin
export var box = "_20-2";
export var checkboxControl = "_20-0";
export var checkboxRow = "_20-a";
export var checked = "_20-3";
export var descriptionSpacer = "_20-c";
export var disabled = "_20-4";
export var icon = "_20-8";
export var input = "_20-1";
export var labelSpacer = "_20-b";
export var large = "_20-7";
export var medium = "_20-6";
export var small = "_20-5";
export var text = "_20-9";